import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../constants';

export const accordionRootStyles: SxProps<Theme> = {
	backgroundColor: Colors.transparent,
	backgroundImage: 'none',
	marginTop: '0 !important',
	boxShadow: 'none',
	borderRadius: '4px !important',
	overflow: 'hidden',
};

export const accordionSummaryStyles: SxProps<Theme> = {
	px: '0px',
	pb: '12px',
	mb: '18px',
	gap: '10px',
	minHeight: '24px !important',
	justifyContent: 'flex-start',

	'&.Mui-expanded': {
		borderBottom: `1px solid ${Colors.white_a10}`,
	},

	'& .MuiAccordionSummary-content, &.Mui-expanded .MuiAccordionSummary-content': {
		mt: '0px',
		mb: '0px',
		flexGrow: 0,
	},

	'& .MuiAccordionSummary-expandIconWrapper': {
		order: 1,
	},
};

export const accordionDetailsStyles: SxProps<Theme> = {
	py: '16px',
	px: '0px',
};
